export enum OPTIONS_SIDEBAR {
  WRAPPER = "optionsSidebar",
  "trust-mandate" = "optionsSidebarTrustMandateButton",
  "notifications" = "optionsSidebarNotificationsButton",
  "pets" = "optionsSidebarPetsButton",
  "holidays" = "optionsSidebarHolidaysButton",
  "replacement" = "optionsSidebarReplacementButton",
}

export enum OPTIONS_HOLIDAYS {
  SKELETON = "skeleton",
  CONTAINER_DESKTOP = "holidaysContainerDesktop",
  CONTAINER_MOBILE = "holidayContainerMobile",
  NO_HOLIDAYS = "holidayNoHolidays",
  NOTIFICATIONS_ADD_HOLIDAY = "holidayNewHolidayAddedNotification",
  BUTTON_EDIT = "holidayEditButton",
  BUTTON_DELETE = "holidayDeleteButton",
  ITEM = "holidayItem",
  ITEM_MOBILE_STATUS = "holidayItemMobileStatus",
}

export enum OPTIONS_MOBILE_NAV {
  NOTIFICATIONS = "optionsMobileNavNotifications",
  PETS = "optionsMobileNavPets",
  HOLIDAYS = "optionsMobileNavHolidays",
  REPLACEMENT = "optionsMobileNavReplacement",
  CLEANING_SUMMARY = "optionsMobileNavCleaningSummary",
}

export enum OPTIONS_HOLIDAYS_ANSWERS {
  YES = "holidayYes",
  NO = "holidayNo",
  IDK = "holidayIdk",
  CONTAINER = "holidayContainer",
}

export enum HOLIDAYS_TABLE_DESKTOP {
  ROW = "holidaysTableDesktopRow",
  STARTING_DATE = "startingDate",
  ENDING_DATE = "endingDate",
  STATUS = "holidaysTableStatus",
}
